import { Card, CardContent, CardHeader, Divider, makeStyles, Button, Grid } from '@material-ui/core'
import React, { useState } from 'react'
import Filter from './components/Filter'
import ChequeSettingsTable from './components/ChequeSettingsTable'
import AddChequeSetting from './components/AddChequeSetting'
import Popup from '../../components/Popup'

const useStyles = makeStyles(theme => ({
    root: {
        minHeight: 100,
        padding: theme.spacing(1)
    },
    content: {
        marginTop: theme.spacing(3)
    },
}))

const ChequeSettings = () => {
    const classes = useStyles()
    const [addChequeSettingPopup, setAddChequeSettingPopup] = useState(false)
    return (
        <Card className={classes.root}>
            <CardHeader title="چک ها" action={
                <Button variant="contained" color="primary" onClick={() => setAddChequeSettingPopup(true)}>
                    اضافه کردن چک
                    </Button>
            } />
            <Popup
                title="اضافه کردن چک"
                openPopup={addChequeSettingPopup}
                setOpenPopup={setAddChequeSettingPopup}
            >
                <AddChequeSetting setPopup={setAddChequeSettingPopup} />
            </Popup>
            <Divider />
            <CardContent>
                <Filter />
                <Grid className={classes.content}>
                    <ChequeSettingsTable />
                </Grid>
            </CardContent>
        </Card>
    )
}

export default ChequeSettings
